import { Skeleton } from '@/shared/components/ui/skeleton';

export function DevicesPendingState() {
  return (
    <div className="flex min-h-0 flex-1 flex-col gap-3 overflow-auto p-4" aria-busy="true">
      <header className="flex flex-wrap items-end justify-between gap-3">
        <div className="space-y-2">
          <Skeleton className="h-5 w-20" />
          <Skeleton className="h-4 w-96 max-w-full" />
        </div>
        <div className="grid gap-1">
          <Skeleton className="h-3 w-20" />
          <Skeleton className="h-9 w-64" />
        </div>
      </header>
      <div className="rounded-lg border p-2">
        <Skeleton className="h-8 w-full" />
        <div className="space-y-2 p-2">
          <Skeleton className="h-8 w-full" />
          <Skeleton className="h-8 w-full" />
          <Skeleton className="h-8 w-full" />
        </div>
      </div>
    </div>
  );
}
